import React from 'react';
import { useDrop } from 'react-dnd';
import history from '../History';
import './RecycleBin.css';
import useSound from 'use-sound';
import dropSound from './../../sounds/drop.mp3';
import hover from './../../sounds/hoverBin.wav';

const RecycleBin = ({ name, description, content, onDrop, isSound }) => {
    const [dropImageSound] = useSound(dropSound, { volume: 0.4 });
    const [hoverImageSound] = useSound(hover, { volume: 0.4 });

    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        // The type (or types) to accept - strings or symbols
        accept: 'TRASH',
        drop: onDrop,
        // Props to collect
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        })
    }))

    const isActive = canDrop && isOver;
    var style = getComputedStyle(document.body)
    let backgroundColor = style.getPropertyValue('--tertiary');
    let background2Color = style.getPropertyValue('--tertiary-light');
    if (isActive) {
        isSound && dropImageSound();
        backgroundColor = style.getPropertyValue('--pink');;
        background2Color = style.getPropertyValue('--pink-light');
    }


    return (
        <div className="recycle-container">
            <div role="RecycleBin" className="recycle-bin" ref={drop} role="RecycleBin" style={{ backgroundColor }} onClick={() => history.push('/' + name)} onMouseEnter={() => isSound && hoverImageSound()}>
                <div className="recycle-bin-container" style={{ backgroundColor: background2Color }}>
                    <div className="recycle-bin-title"> {isActive ? 'Throw away' : name} </div>
                </div>
            </div>
            <div className="tooltip">
                {description}
            </div>
        </div>);
};


export default RecycleBin;